import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal, Form } from "reactstrap";
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { styled } from '@mui/system';
import { Input as BaseInput } from '@mui/base/Input';
import { pOPaymentList, genertePaymentList, getPendingPaymentsPoList, pendingInsurancePayment, addInsurancePaymentHistory } from "../../../api/po";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import Grid from '@mui/material/Grid';

const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const InputElement = styled('input')(
    ({ theme }) => `
    width: 120px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
        };

    &:hover {
      border-color: ${blue[400]};
    }

    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }

    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
const PaymentPo = () => {
    // const [showList, setShowList] = useState(false);
    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Insurance Charge Payment'))

    const [invoiceDetails, setInvoiceDetails] = useState({
      total_amount: null,
      remaining_amount: null,
      insurance_id: null
    })
    const [gridLoad, setGridLoad] = useState(false);
    const [invoiceList, setInvoiceList] = useState([])
    const initialState = {
        invoice_id: null,
        bank: null,
        payment_date: null,
        payment_ref_no: '',
        payment_type: null,
        amount: '',
        rate: '',
        func_amount: null,
    }
    const [pendingInvoiceList, setPendingInvoiceList] = useState([])
    const [invoiceValue, setInvoiceValue] = useState(initialState)
    const [paymentRows, setPaymentRows] = useState([]);
    const [modalState, setModalState] = useState(false)

    const Input = React.forwardRef(function CustomInput(props, ref) {
        return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
    });
    document.title = "Dashboard | Procurement Dashboard";

    const bankOptions = [
      { label: "ICICI BANK", value: "ICICI BANK" },
      { label: "SBI", value: "SBI" },
      { label: "AXIS BANK", value: "AXIS BANK" },
      { label: "BANK OF BARODA", value: "BANK OF BARODA" },
    ];

    const paymentOptions = [
      { label: "CHEQUE", value: "CHEQUE" },
      { label: "NEFT", value: "NEFT" },
      { label: "BANK TRANSFER", value: "BANK TRANSFER" },
    ];

    const formik = useFormik({
      initialValues: initialState,
      enableReinitialize: true,
      validationSchema: Yup.object({
        invoice_id: Yup.string().nullable(true).required("Please Select Invoice Number"),
        bank: Yup.string().nullable(true).required("Please Select Your Bank")
          .oneOf(bankOptions.map(option => option.value), 'Selected bank is not valid'),
        payment_date: Yup.date().required("Please Select Payment Date"),
        payment_ref_no: Yup.string(),
        payment_type: Yup.string().nullable(true).required("Please Select Payment Type").oneOf(paymentOptions.map(option => option.value), 'Selected Payment Option is not valid'),
        amount: Yup.number()
          .required('Please Enter Amount')
          .when('invoice_id', {
            is: (invoice_id) => !!invoice_id,
            then: Yup.number().max(invoiceDetails.remaining_amount, 'Amount exceeds the maximum limit for the selected Invoice'),
          }),
        rate: Yup.number().required("Please Enter Rate"),
      }),

      onSubmit: (values) => {
        toggleModal()
      }
    })




    const columns = [
        {
            field: 'Sl_No', headerName: 'Sl.No', flex: .5,
            resizable: false,
            sortable: false,
        },
        {
            field: 'vendor_name',
            headerName: 'Vendor Name',
            headerClassName: 'table-header-background',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
        },
        {
            field: 'payment_date',
            headerName: 'Date',
            headerClassName: 'table-header-background',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        // {
        //     field: 'payment_ref_no',
        //     headerName: 'Payment Reference Number',
        //     // headerClassName: 'break-header',
        //     // cellClassName: 'product_name_wrap',
        //     // width: 160,
        //     editable: false,
        //     resizable: false,
        //     sortable: false,
        //     flex: 1,
        //     headerAlign: 'center',
        //     cellClassName: 'center-aligndata',
        // },
        {
            field: 'insurance_no',
            headerName: 'Insurance No.',
            headerClassName: 'break-header',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // cellClassName: 'product_name_wrap',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: 'item',
            headerName: 'Item',
            // headerClassName: 'break-header',
            // cellClassName: 'product_name_wrap',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
        },
        {
            field: 'qty',
            headerName: 'QTY',
            // headerClassName: 'break-header',
            // cellClassName: 'product_name_wrap',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
        },
        {
            field: 'unit_price',
            headerName: 'Unit Price',
            headerClassName: 'table-header-background',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
        },
        {
          field: 'Total_auto',
          headerName: 'Total(Auto)',
          headerClassName: 'table-header-background',
          // width: 160,
          editable: false,
          resizable: false,
          sortable: false,
          flex: 1,
          headerAlign: 'center',
          cellClassName: 'center-aligndata',
      },
      {
          field: 'conversition_rate',
          headerName: 'Conversition Rate',
          headerClassName: 'table-header-background',
          // width: 160,
          editable: false,
          resizable: false,
          sortable: false,
          flex: 1,
          headerAlign: 'center',
          cellClassName: 'center-aligndata',
      },
      {
        field: 'amount_auto',
        headerName: 'Amount(Auto)',
        headerClassName: 'table-header-background',
        // width: 160,
        editable: false,
        resizable: false,
        sortable: false,
        flex: 1,
        headerAlign: 'center',
        cellClassName: 'center-aligndata',
    },
    ];

    // const [inputValue, setInputValue] = useState('');
    // const [selectedValue, setSelectedValue] = useState(null);

    const searchPOPaymentHistory = async (payload = {}) => {
        try {
            const selectedInvoice = pendingInvoiceList.filter((element) => element.id == payload.invoice_id)

            setGridLoad(true)

            const result = selectedInvoice[0].procurementInsurance[0].procurementInsurancePayment;

            if(result.length >0){
                const formattedProducts = result.map((payment, index) => ({
                    id: payment.id, // Assuming index + 1 as ID
                    Sl_No: index + 1, // Serial Number
                    invoice_no: selectedInvoice[0].invoice_number,
                    payment_date: payment.payment_date,
                    payment_ref_no: payment.payment_ref_no ? payment.payment_ref_no : '--',
                    bank: payment.bank,
                    amount: payment.amount,
                    rate: payment.rate,
                    func_amount: payment.func_amount,
                    payment_no: payment.payment_no
                }));
                setPaymentRows(formattedProducts)
            } else {
                setPaymentRows([])
            }
        }
        catch(error){
            toast.error('Error in fetching approval list for purchase')
            console.log(error)
        }
        finally{
            setGridLoad(false)
        }
    }

    const getPOList = async () => {
      try {
        const res = await pendingInsurancePayment();

        console.log("pendingInsurancePayment response:", res);

        const result = res.data.pendingInvoice;
        if(res.statusCode === 200 && result.length >0) {
          const formattedInvoiceList = result.map((invoice) => ({
            label: invoice.invoice_number,
            value: invoice.id
          }))

          console.log("formattedInvoiceList:", formattedInvoiceList);
          setPendingInvoiceList(result)
          setInvoiceList(formattedInvoiceList);
        }
      } catch (error) {
        console.log(error)
        toast.error('Error in fetching Invoice List')
      }
    }

    useEffect(() => {
      getPOList()
    }, [])

    const getInvoiceDetails = async (payload = {}) => {
      const selectedInvoice = pendingInvoiceList.filter((element) => element.id == payload.invoice_id)
      setInvoiceDetails({
        total_amount: selectedInvoice[0].procurementInsurance[0].amount,
        remaining_amount: selectedInvoice[0].procurementInsurance[0].insurance_pending_payment_amount,
        insurance_id: selectedInvoice[0].procurementInsurance[0].id,
      })
    }

    useEffect(() => {
      if (invoiceValue.po_id) {
        getInvoiceDetails({ invoice_id: invoiceValue.po_id.value })
        searchPOPaymentHistory({invoice_id: invoiceValue.po_id.value})
      } else {
        setInvoiceDetails({
          total_amount: null,
          remaining_amount: null,
          insurance_id: null
        })
        setPaymentRows([]);
      }
    }, [invoiceValue.po_id])

    const toggleModal = () => {
      setModalState(prev => !prev)
    }

    const handleSubmit = async () => {
        try {
          const payload = {
            ...formik.values,
            insurance_id: invoiceDetails.insurance_id,
            func_amount: formik.values.amount * formik.values.rate
          }

          payload.invoice_id = invoiceValue.po_id?.value;

          if(formik.values.payment_ref_no == ""){
            delete payload["payment_ref_no"];
          }


            if (formik.values.payment_date) {
                payload.payment_date = dayjs(formik.values.payment_date).format("YYYY-MM-DD");
            }
            console.log('payload to be submitted', payload)
            await addInsurancePaymentHistory(payload)
            toast.success('Insurance Payment generated successfully')
            setInvoiceValue(initialState)
            formik.resetForm()
            getPOList()
        } catch (error) {
            console.log(error)
            toast.error('Error in generating payment list')
        } finally {
          toggleModal()
        }

    }

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <div>
              <Card>
                <CardBody>
                  <div>
                  <Form onSubmit={formik.handleSubmit}>
                    <div className="d-flex align-items-center justify-content-between mb-2 gap-2">

                      <div className="d-flex align-items-center gap-2">
                        <p className="mb-0 me-2 requisition_type_text">
                          {/* Select Invoice */}
                          Add Insurance
                        </p>
                        <div>
                          <Autocomplete
                            className="invoice_autofield"
                            sx={{ width: 190 }}
                            options={invoiceList}
                            name="po_id"
                            value={formik.values.invoice_id}
                            onBlur={formik.handleBlur}
                            onChange={(_, value) => {
                              setInvoiceValue((prev) => ({
                                ...prev,
                                po_id: value,
                              }));
                              formik.setFieldValue('invoice_id', value.label)
                            }}
                            renderInput={(params) => (
                              <TextField {...params}
                                label="Invoice No"
                                name="po_id"
                                error={formik.touched.invoice_id && Boolean(formik.errors.invoice_id)}
                                helperText={formik.touched.invoice_id && formik.errors.invoice_id}
                              />
                            )}
                          />
                        </div>
                        <div className="d-flex gap-3">
                          
                          {
                            invoiceDetails.total_amount && <><span className="ms-2">
                                <span style={{ fontSize: '15px', fontWeight: '500', color: '#545B69' }}> Insurance Amount :</span><span className="ms-1" style={{ fontSize: '14px', fontWeight: '500' }}> {invoiceDetails.total_amount}</span>
                              </span><div style={{ borderRight: '1px solid rgb(175 172 172)', height: '25px' }}></div></>
                          }
                          {
                            invoiceDetails.remaining_amount && <span>
                             <span style={{ fontSize: '15px', fontWeight: '500', color: '#545B69' }}> Remaining Amount :</span> <span className="ms-1" style={{ fontSize: '14px', fontWeight: '500' }}>{invoiceDetails.remaining_amount}</span>
                            </span>
                          }
                        </div>
                      </div>

                    </div>
                    <div
                      className="p-3 mt-3"
                      style={{
                        backgroundColor: "#FAFDFF",
                        border: "1px solid #C3E8FF",
                        borderRadius: '5px'
                      }}
                    >
                      <div className="d-flex align-items-center mb-2 gap-3 flex-wrap">
                      <Grid container item xs={12} sm={12} spacing={1}>
                      <Grid item xs={3}>
                          {/* <div className="d-flex align-items-center gap-3">
                            <div style={{ width: "120px" }}> */}
                            <Autocomplete
                              className="invoice_autofield"
                              // sx={{ width: 205 }}
                              sx={{ width: '100%', }}
                              options={paymentOptions}
                              name="payment_type"
                              value={formik.values.payment_type}
                              onBlur={formik.handleBlur}
                              onChange={(_, value) =>
                                formik.setFieldValue('payment_type', value.value)
                              }
                              renderInput={(params) => (
                                <TextField {...params}
                                 label="Vendor Name"
                                 name="payment_type"
                                 error={formik.touched.payment_type && Boolean(formik.errors.payment_type)}
                                 helperText={formik.touched.payment_type && formik.errors.payment_type}
                                 />
                              )}
                            />
                            </Grid>
                      <Grid item xs={3}>
                        {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                          {/* <div className="d-flex align-items-center gap-3">
                            <div style={{ width: "55px" }}> */}
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                className="payment_date date_picker_fullwidth"
                                label="Date"
                                name="payment_date"
                                onBlur={formik.handleBlur}
                                value={formik.values.payment_date}
                                onChange={(value) =>
                                  formik.setFieldValue('payment_date', value)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    error={formik.touched.payment_date && Boolean(formik.errors.payment_date)}
                                    helperText={formik.touched.payment_date && formik.errors.payment_date}
                                  />
                                )}
                              />
                            </LocalizationProvider>
                            </Grid>
                        {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                        <Grid item xs={3}>
                        {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                          {/* <div className="d-flex align-items-center gap-3">
                            <div style={{ width: "120px" }}> */}
                            <TextField
                               className="create_requisition_textfield"
                              label="Insurance No"
                              name="payment_ref_no"
                              value={formik.values.payment_ref_no}
                              onChange={(event) =>
                                formik.setFieldValue('payment_ref_no', event.target.value)
                              }
                              onBlur={formik.handleBlur}
                              variant="outlined"
                              // sx={{ width: 205 }}
                              sx={{ width: '100%', }}
                              error={formik.touched.payment_ref_no && Boolean(formik.errors.payment_ref_no)}
                              helperText={formik.touched.payment_ref_no && formik.errors.payment_ref_no}
                            />
                          {/* </div> */}
                          </Grid>
                        {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                        <Grid item xs={3}>
                          <div className="d-flex align-items-center gap-3">
                            <TextField
                               className="create_requisition_textfield"
                              label="Item"
                              name="payment_ref_no"
                              value={formik.values.payment_ref_no}
                              onChange={(event) =>
                                formik.setFieldValue('payment_ref_no', event.target.value)
                              }
                              onBlur={formik.handleBlur}
                              variant="outlined"
                              // sx={{ width: 205 }}
                              sx={{ width: '100%', }}
                              error={formik.touched.payment_ref_no && Boolean(formik.errors.payment_ref_no)}
                              helperText={formik.touched.payment_ref_no && formik.errors.payment_ref_no}
                            />
                          </div>
                        {/* </div> */}
                        </Grid>
                        </Grid>
                        <Grid container item xs={12} sm={12} spacing={1}>
                      <Grid item xs={2}>
                          {/* <div className="d-flex align-items-center gap-3">
                            <div style={{ width: "120px" }}> */}
                            <Autocomplete
                               className="invoice_autofield"
                              // sx={{ width: 205 }}
                              sx={{ width: '100%', }}
                              options={paymentOptions}
                              name="payment_type"
                              value={formik.values.payment_type}
                              onBlur={formik.handleBlur}
                              onChange={(_, value) =>
                                formik.setFieldValue('payment_type', value.value)
                              }
                              renderInput={(params) => (
                                <TextField {...params}
                                 label="Vendor Name"
                                 name="payment_type"
                                 error={formik.touched.payment_type && Boolean(formik.errors.payment_type)}
                                 helperText={formik.touched.payment_type && formik.errors.payment_type}
                                 />
                              )}
                            />
                            </Grid>
                      <Grid item xs={2}>
                        {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                          {/* <div className="d-flex align-items-center gap-3">
                            <div style={{ width: "55px" }}> */}
                            <TextField
                               className="create_requisition_textfield"
                              label="Unit Price"
                              name="payment_ref_no"
                              value={formik.values.payment_ref_no}
                              onChange={(event) =>
                                formik.setFieldValue('payment_ref_no', event.target.value)
                              }
                              onBlur={formik.handleBlur}
                              variant="outlined"
                              // sx={{ width: 205 }}
                              sx={{ width: '100%', }}
                              error={formik.touched.payment_ref_no && Boolean(formik.errors.payment_ref_no)}
                              helperText={formik.touched.payment_ref_no && formik.errors.payment_ref_no}
                            />
                            </Grid>
                        {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                        <Grid item xs={2}>
                        {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                          {/* <div className="d-flex align-items-center gap-3">
                            <div style={{ width: "120px" }}> */}
                            <TextField
                               className="create_requisition_textfield"
                              label="Total"
                              name="payment_ref_no"
                              value={formik.values.payment_ref_no}
                              onChange={(event) =>
                                formik.setFieldValue('payment_ref_no', event.target.value)
                              }
                              onBlur={formik.handleBlur}
                              variant="outlined"
                              // sx={{ width: 205 }}
                              sx={{ width: '100%', }}
                              error={formik.touched.payment_ref_no && Boolean(formik.errors.payment_ref_no)}
                              helperText={formik.touched.payment_ref_no && formik.errors.payment_ref_no}
                            />
                          {/* </div> */}
                          </Grid>
                        {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                        <Grid item xs={2}>
                          <div className="d-flex align-items-center gap-3">
                            <TextField
                               className="create_requisition_textfield"
                              label="Conversion Rate"
                              name="payment_ref_no"
                              value={formik.values.payment_ref_no}
                              onChange={(event) =>
                                formik.setFieldValue('payment_ref_no', event.target.value)
                              }
                              onBlur={formik.handleBlur}
                              variant="outlined"
                              // sx={{ width: 205 }}
                              sx={{ width: '100%', }}
                              error={formik.touched.payment_ref_no && Boolean(formik.errors.payment_ref_no)}
                              helperText={formik.touched.payment_ref_no && formik.errors.payment_ref_no}
                            />
                          </div>
                        {/* </div> */}
                        </Grid>
                        <Grid item xs={2}>
                          <div className="d-flex align-items-center gap-3">
                            <TextField
                               className="create_requisition_textfield"
                              label="Amount"
                              name="payment_ref_no"
                              value={formik.values.payment_ref_no}
                              onChange={(event) =>
                                formik.setFieldValue('payment_ref_no', event.target.value)
                              }
                              onBlur={formik.handleBlur}
                              variant="outlined"
                              // sx={{ width: 205 }}
                              sx={{ width: '100%', }}
                              error={formik.touched.payment_ref_no && Boolean(formik.errors.payment_ref_no)}
                              helperText={formik.touched.payment_ref_no && formik.errors.payment_ref_no}
                            />
                          </div>
                        {/* </div> */}
                        </Grid>
                        <Grid item xs={2}>
                          <div className="d-flex align-items-center">
                            <button className="save_button mt-1" type="submit">
                              Submit
                            </button>
                          </div>
                        {/* </div> */}
                        </Grid>
                        </Grid>
                      </div>
                    </div>
                  </Form>
                  </div>
                </CardBody>
              </Card>
              <Modal
                isOpen={modalState}
                toggle={toggleModal}
              >
                <div className="d-flex justify-content-between me-2 mt-3">
                  <h4 className="ms-3">
                    Do You Want To Submit This Payment?
                  </h4>
                  <div className="d-flex justify-content-end me-3 modal_close">
                    <i className="ri-close-line" onClick={toggleModal}></i>
                  </div>
                </div>
                <hr className="mb-2 mt-1 ms-3 me-3"></hr>
                <ModalBody className="pt-2">
                <div>
                    <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>Payment Mode</th>
                                            <th>Bank</th>
                                            <th>Amount</th>
                                            <th>Rate</th>
                                            <th>Func. Amount</th>
                                        </tr>
                                    </thead>
             

                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td>{formik.values.payment_type}</td>
                                                <td>{formik.values.bank}</td>
                                                <td>{formik.values.amount}</td>
                                                <td>{formik.values.rate}</td>
                                                <td>{formik.values.amount * formik.values.rate}</td>

                                            </tr>
                                        
                                    </tbody>
                                    {/* <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="3">Total :</th>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.total_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.received_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.unit_price;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + (currentObject.unit_price * currentObject.received_qty * payload.conversion_rate);
                                                }, 0)}</td>
                                        </tr>
                                    </tfoot> */}
                                </table>
                    </div>
                    <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                  <div className="d-flex align-items-center mt-4 justify-content-center">
                    <button
                      className="yes_button d-flex align-items-center"
                      onClick={handleSubmit}
                    >
                      Yes
                    </button>
                    <button
                      className="no_button d-flex align-items-center ms-3"
                      onClick={toggleModal}
                    >
                      No
                    </button>
                  </div>
                </ModalBody>
              </Modal>
              <div>
                <div>
                  <h4 className="mb-0 requisition_text">Insurance</h4>
                </div>
                <Box
                  sx={{
                    height: '100%',
                    width: "100%",
                    marginBottom: "1.5rem",
                    marginTop: "10px",
                  }}
                >
                  <DataGrid
                    autoHeight
                    className="table_header_background"
                    headerClassName="custom-header-cell"
                    getRowHeight={() => "auto"}
                    rows={paymentRows}
                    loading={gridLoad}
                    columns={columns}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 5,
                        },
                      },
                    }}
                    pageSizeOptions={[5]}
                    disableRowSelectionOnClick
                    disableColumnMenu
                    disableColumnResize={true}
                    componentsProps={{
                      cell: {
                        disableClick: true,
                      },
                    }}
                    sx={{
                      "& .MuiDataGrid-cell": {
                        "& .MuiDataGrid-cell--textOverflow": {
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        },
                      },
                    }}
                  />
                </Box>
              </div>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
};

export default PaymentPo;
